
(function () {
  function scrollStep(scroller) {
    const inner = scroller.querySelector('.swipe-mobile__inner');
    const first = inner?.firstElementChild;
    if (!first) return Math.round(scroller.clientWidth * 0.85);
    const gap = inner ? parseFloat(window.getComputedStyle(inner).columnGap || '0') || 0 : 0;
    return first.getBoundingClientRect().width + gap;
  }

  function syncDisabled(scroller, prev, next) {
    const max = Math.max(0, scroller.scrollWidth - scroller.clientWidth - 2);
    if (prev) {
      if (scroller.scrollLeft <= 2) prev.setAttribute('disabled', '');
      else prev.removeAttribute('disabled');
    }
    if (next) {
      if (scroller.scrollLeft >= max) next.setAttribute('disabled', '');
      else next.removeAttribute('disabled');
    }
  }

  function initRail(rail) {
    if (!rail) return;
    const scroller = rail.querySelector('.wim-tab-offers__products-wrap.swipe-mobile');
    if (!scroller) return;

    const nav = rail.querySelector('.wim-tab-offers__scroll-nav');
    if (!nav) return;

    const prev = nav.querySelector('.swiper-button-prev');
    const next = nav.querySelector('.swiper-button-next');
    if (!prev || !next) return;

    const onScroll = () => syncDisabled(scroller, prev, next);

    if (!rail.__wimOffersSlideMobileNavBound) {
      prev.addEventListener('click', () => scroller.scrollBy({ left: -scrollStep(scroller), behavior: 'smooth' }));
      next.addEventListener('click', () => scroller.scrollBy({ left: scrollStep(scroller), behavior: 'smooth' }));
      scroller.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      rail.__wimOffersSlideMobileNavBound = true;
    }

    onScroll();
  }

  function init(root) {
    if (!root) return;
    root.querySelectorAll('.wim-tab-offers__rail').forEach(initRail);
  }

  function initAll() {
    document.querySelectorAll('[data-wim-offers-slide-mobile-nav]').forEach(init);
  }

  initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

